import React from "react";
import InformationBanner from "../../../design-system-components/InformationBanner/InformationBanner";
import { defineMessages, useIntl } from "react-intl";
import { useUrl } from "../../../hooks/usePage";
import { Pagetype } from "../../../interfaces/Config";
import { withFeatureFlag } from "@evidenceb/athena-common/modules/FeatureFlags";

const WithAiInformationBanner = () => {
    const urlGuide = useUrl(Pagetype.CONTENTPAGE);
    const intl = useIntl();
    return (
        <InformationBanner
            data={{
                content: intl.formatMessage(messages.aiInformation, {
                    a: (chunks: any[]) => <a href={urlGuide}>{chunks}</a>,
                }),
                dismissable: true,
            }}
        />
    );
};
export default withFeatureFlag("displayAiBannerInTeacherModuleList")(
    WithAiInformationBanner
);

const messages = defineMessages({
    aiInformation: {
        id: "informationBanner-aiInformation",
        defaultMessage:
            "The AI Modules mode of the teacher application does not include artificial intelligence. This catalog allows you to explore the resources that will be offered to your students by the adaptive learning algorithm. You can consult your guide for <a>explanations on how our AI algorithms work</a>.",
    },
});
